import Vue from 'vue';

export default {
    pagarNomina(parametros) {
        return Vue.axios.get("pagos/cuentas-bancarias" , { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    generarTxt(parametros) {
        return Vue.axios.post("pagos/generar-layout", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
}